import { Schema, arrayOf } from "normalizr";

export const chat = new Schema("chat");
export const message = new Schema("message");
export const user = new Schema("user");

export const chats = arrayOf(chat);
export const messages = arrayOf(message);
export const users = arrayOf(user);


chat.define({
    messages: messages
});


// WEBPACK FOOTER //
// ./src/redux/schema/index.tsx